import { render, staticRenderFns } from "./TrendingProductsSection.vue?vue&type=template&id=1dee80b7&"
import script from "./TrendingProductsSection.vue?vue&type=script&lang=js&"
export * from "./TrendingProductsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports